var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.25C11.8354 17.25 12.1189 17.1342 12.3505 16.9026C12.5821 16.671 12.6979 16.3875 12.6979 16.0521C12.6979 15.7167 12.5821 15.4332 12.3505 15.2016C12.1189 14.97 11.8354 14.8542 11.5 14.8542C11.1646 14.8542 10.8811 14.97 10.6495 15.2016C10.4179 15.4332 10.3021 15.7167 10.3021 16.0521C10.3021 16.3875 10.4179 16.671 10.6495 16.9026C10.8811 17.1342 11.1646 17.25 11.5 17.25ZM10.6375 13.5604H12.4104C12.4104 12.9854 12.4743 12.5622 12.6021 12.2906C12.7299 12.0191 13.0014 11.6757 13.4167 11.2604C13.9757 10.7014 14.371 10.2342 14.6026 9.85885C14.8342 9.48351 14.95 9.05625 14.95 8.57708C14.95 7.73056 14.6625 7.04774 14.0875 6.52865C13.5125 6.00955 12.7378 5.75 11.7635 5.75C10.8851 5.75 10.1384 5.96562 9.52344 6.39687C8.90851 6.82812 8.48125 7.42708 8.24167 8.19375L9.82292 8.81667C9.93472 8.38542 10.1583 8.03802 10.4938 7.77448C10.8292 7.51094 11.2205 7.37917 11.6677 7.37917C12.099 7.37917 12.4583 7.49497 12.7458 7.72656C13.0333 7.95816 13.1771 8.26562 13.1771 8.64896C13.1771 8.92049 13.0892 9.20799 12.9135 9.51146C12.7378 9.81493 12.4424 10.1503 12.0271 10.5177C11.5 10.9809 11.1366 11.4241 10.937 11.8474C10.7373 12.2707 10.6375 12.8417 10.6375 13.5604ZM4.79167 20.125C4.26458 20.125 3.81337 19.9373 3.43802 19.562C3.06267 19.1866 2.875 18.7354 2.875 18.2083V4.79167C2.875 4.26458 3.06267 3.81337 3.43802 3.43802C3.81337 3.06267 4.26458 2.875 4.79167 2.875H18.2083C18.7354 2.875 19.1866 3.06267 19.562 3.43802C19.9373 3.81337 20.125 4.26458 20.125 4.79167V18.2083C20.125 18.7354 19.9373 19.1866 19.562 19.562C19.1866 19.9373 18.7354 20.125 18.2083 20.125H4.79167Z",
    fill: "#695BD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help_center.f56305e162da0505394e7115be47db41.svg";
export { ForwardRef as ReactComponent };